import { memo, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import cnames from 'classnames'
import { isEmpty } from 'Utils/objects'
import CustomFieldsForm from './CustomFieldsForm/CustomFieldsForm'
import PageSubtitle from 'Shared/PageSubtitle'
import TagInputField from 'Shared/TagInputField/TagInputField'

const MoreInformation = ({ customFieldsData, isPos, licensePlatesInputProps, loading, setFieldValue, showDivider,
                           showLicensePlatesInput }) => {
  const [customFields, setCustomFields] = useState([])

  const classNameContainer = cnames('more-information mb-4', { 'skeleton-loading': loading })

  useEffect(() => {
    setCustomFields(customFieldsData)
    setFieldValue('customFields', customFieldsData)
  }, [customFieldsData])

  if (isEmpty(customFields) && !showLicensePlatesInput) return null

  return (
    <>
      <div className={classNameContainer}>
        <PageSubtitle text="More Information" />

        {showLicensePlatesInput && (
          <TagInputField {...licensePlatesInputProps} />
        )}

        <CustomFieldsForm customFields={customFields} isPos={isPos} />
      </div>

      {showDivider && <hr />}
    </>
  )
}

MoreInformation.defaultProps = {
  customFieldsData: [],
  licensePlatesInputProps: {
    name: 'licensePlates',
    placeholder: 'Add a license plate and press Enter',
  },
  setFieldValue: () => {},
  showDivider: false,
  showLicensePlatesInput: false,
}

MoreInformation.propTypes = {
  customFieldsData: PropTypes.arrayOf(PropTypes.shape({})),
  licensePlatesInputProps: PropTypes.shape({}),
  setFieldValue: PropTypes.func,
  showDivider: PropTypes.bool,
  showLicensePlatesInput: PropTypes.bool,
}

export default memo(MoreInformation)
